import memoize from 'memoize-one';
import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useCurrentUser } from 'my-core/hooks';

import ShareActivityDialog from './ShareActivityDialog';

import { createOnlineCourseActivityShare } from 'my-actions/OnlineCourseActivityShareActions';

function ShareActivityDialogCtnr(props) {
  const { onClose, onlineCourse, onlineCourseActivityId, open } = props;
  const user = useCurrentUser();
  const dispatch = useDispatch();
  const share = useSelector(state => getShare(state.onlineCourseActivityShares.items, user.id, onlineCourseActivityId));

  const createKey = useRef();
  const createStatus = useSelector(state => state.onlineCourseActivityShares.status[createKey.current]);
  const fetching = !share && (!createStatus || !!createStatus.creating);

  useEffect(() => {
    if (open && !share) {
      createKey.current = Date.now();
      dispatch(createOnlineCourseActivityShare(onlineCourseActivityId, createKey.current));
    }
  }, [open, onlineCourseActivityId, dispatch, share]);

  return (
    <ShareActivityDialog
      error={createStatus?.error}
      fetching={fetching}
      onClose={onClose}
      onlineCourse={onlineCourse}
      open={open}
      share={share}
    />
  );
}

const getShare = memoize((shares, userId, onlineCourseActivityId) =>
  Object.values(shares).find(s => s.user_id === userId && s.online_course_activity_id === onlineCourseActivityId),
);

ShareActivityDialogCtnr.propTypes = {
  onlineCourseActivityId: PropTypes.number.isRequired,
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default ShareActivityDialogCtnr;
